import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { FormModeProvider } from '../../base/contexts/FormModeContext'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { ProductoInputProps } from './interfaces/producto.interface'
import {
  ProductoFormMode,
  productoFormModeDefault,
  productoFormModelConfig,
} from './services/productoFormMode'

const AppProductosGestion = Loadable(lazy(() => import('./view/Productos')))
const AppProductoNuevo = Loadable(lazy(() => import('./view/ProductoRegistro')))
const AppProductoActualizar = Loadable(lazy(() => import('./view/ProductoActualizar')))
const AppProductoConsultar = Loadable(lazy(() => import('./view/ProductoActualizar'))) // O vista de consulta si existe

export const productosRouteMap = {
  gestion: '/productos/gestion',
  nuevo: '/productos/nuevo',
  modificar: '/productos/modificar',
  consultar: '/productos/consultar',
}

const productosRoutes = [
  {
    path: productosRouteMap.gestion,
    element: <AppProductosGestion />,
    auth: authRoles.admin,
  },
  {
    path: productosRouteMap.nuevo,
    element: (
      <FormModeProvider<ProductoInputProps, ProductoFormMode>
        mode={'create'}
        config={productoFormModelConfig}
        defaults={productoFormModeDefault}
      >
        <AppProductoNuevo />
      </FormModeProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: `${productosRouteMap.modificar}/:id`,
    element: (
      <FormModeProvider<ProductoInputProps, ProductoFormMode>
        mode={'edit'}
        config={productoFormModelConfig}
        defaults={productoFormModeDefault}
      >
        <AppProductoActualizar />
      </FormModeProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: `${productosRouteMap.consultar}/:id`,
    element: (
      <FormModeProvider<ProductoInputProps, ProductoFormMode>
        mode={'consult'}
        config={productoFormModelConfig}
        defaults={productoFormModeDefault}
      >
        <AppProductoConsultar />
      </FormModeProvider>
    ),
    auth: authRoles.admin,
  },
]

export default productosRoutes
